export const trigger = `bg-white py-2.5 px-2 rounded-lg flex items-center justify-between text-ll-placeholder font-medium w-28 shadow-lg`;
export const highlight = `text-ll-primary`;
export const icon = `data-[is-open=true]:rotate-180 transition-transform duration-50 ease-in-out`;

export const content = `bg-white py-3 w-28 mt-0.5 rounded-lg overflow-hidden shadow-lg`;
export const option = `px-4 py-2.5 cursor-pointer text-ll-placeholder font-medium hover:text-ll-on-surface hover:bg-ll-surface`;
